import { opalBase } from './base.js';
import { cardo } from './cardo.js';
import { inter } from './inter.js';
export const opalStyle = (family) => {
    if (family === 'Inter') {
        return inter;
    }
    if (family === 'Cardo') {
        return cardo;
    }
    return opalBase;
};
//# sourceMappingURL=index.js.map